module.exports = __webpack_public_path__ + "static/img/10026.5fe49b9c.png";